import { Text, View } from '@react-pdf/renderer';
import formatNumber from 'helpers/formatNumber';
import React from 'react';
import { OperationType } from 'screens/Applications&WorkOrders/RouteAdmin';
import ActualAcresLabel from '../ActualAcresLabel';

interface PropertiesTableFooterProps {
  totalAppliedAcreage: number;
  operationType: OperationType;
  title?: string;
  actualAcresLabel?: string;
}

const PropertiesTableFooter: React.FC<PropertiesTableFooterProps> = ({
  totalAppliedAcreage,
  operationType,
  title = 'Total Applied Acreage',
  actualAcresLabel = 'Actual Acres'
}) => {
  const isWorkOrder = operationType === OperationType.WORK_ORDER;

  return (
    <View wrap={false}>
      <View
        style={{
          width: '100%',
          padding: 4,
          backgroundColor: '#F3F4F6',
          borderBottom: '1px solid #DFE2E7',
          color: '#14151C',
          fontFamily: 'Noto Sans',
          fontSize: 10,
          textAlign: 'right'
        }}
      >
        <Text>{title}</Text>
      </View>
      <View style={{ padding: 4 }}>
        <Text
          style={{
            fontFamily: 'Noto Sans',
            fontSize: 9,
            textAlign: 'right'
          }}
        >
          {formatNumber(totalAppliedAcreage, 'ac')}
        </Text>
        {isWorkOrder && (
          <View
            style={{
              width: '16.51%',
              textAlign: 'right',
              marginLeft: 'auto',
              minWidth: 88
            }}
          >
            <ActualAcresLabel label={actualAcresLabel} />
          </View>
        )}
      </View>
    </View>
  );
};

export default PropertiesTableFooter;
